import $ from 'jquery';
import constants from 'Constants';
import listService from 'ListService';
import _ from 'lodash';
import util from 'util/Util';
import textUtil from 'util/TextUtil';
import BaseTableView from 'properties/BaseTableView'
import Template from 'report/properties/main/data.ejs';
import FormatView from 'report/properties/FormatView';
import MainDataAggregateView from 'report/properties/main/MainDataAggregateView';
import FormulaModal from 'common-views/MainFormulaModalView';
import ReportFormulaModal from 'common-views/ReportFilterFormulaModalView';
import { Model } from 'backbone';
import formModel from 'formModel';
import eventBus from 'EventBus.js';

class MainDataView extends BaseTableView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;
        this.gridEl = constants.PROP_MAIN_TABLE;
        this.config = opts.config || {};
        this.minRows = 7;

        this.formatFields = ['numberDecimals', 'numberDecimalSeparator', 'numberThousandSeparator', 'numberSymbol',
            'dateFormat', 'time24Hour', 'timeShowSeconds', 'booleanYes', 'booleanNo', 'percentageDecimals'];

        this.events = {
            "click .itemNew"                : "itemNew",
            "click .itemRemove"             : "itemRemove",
            "click .itemUp"                 : "itemUp",
            "click .itemDown"               : "itemDown",
            "click .itemList"               : "itemSpaceEvenly",
            "click #alignment img"          : "updateAlignment",
            'click #formula'                : 'showFormulaModal',
            "change input[type=checkbox]"   : "updateCheckAttributes",
            "change input[type=text]"       : "updateAttributes",
            'blur input[type=text]'         : 'lostFocus',
            'focus input[type=text]'        : 'getFocus',
            "change #controlState"          : 'updateAttributes',
            "change #columnFieldId"         : 'updateColumnField',
            "change #columnSort"            : 'updateSelectAttributes',
            "change #columnFormat"          : 'updateSelectAttributes',
            "change #columnAggregate"       : 'updateSelectAttributes',
            "change #dataSource"            : "updateAttributes",
            "change #numberDecimalSeparator": "updateFormatAttributes",
            "change #numberThousandSeparator": "updateFormatAttributes",
            "change #dateFormat"            : "updateFormatAttributes"
        };

        this.model.set({
            colModel: [
                {
                    name: 'aggregation',
                    index: 'aggregation',
                    hidden: true,
                    editable: false
                },
                {
                    name: 'align',
                    index: 'align',
                    hidden: true,
                    editable: false
                },
                {
                    name: 'caption',
                    index: 'caption',
                    width: 100,
                    editable: true
                },
                {
                    name: 'fieldDataType',
                    index: 'fieldDataType',
                    hidden: true,
                    editable: false
                },
                {
                    name: 'field',
                    index: 'field',
                    width: 100,
                    editable: false
                },
                {
                    name: 'fieldId',
                    index: 'fieldId',
                    editable: false,
                    hidden: true
                },
                {
                    name: 'format',
                    index: 'format',
                    editable: false,
                    hidden: true
                },
                {
                    name: 'formatoption',
                    index: 'formatoption',
                    editable: false,
                    hidden: true
                },
                {
                    name: 'setDynamicFilter',
                    index: 'setDynamicFilter',
                    editable: false,
                    hidden: true
                },
                {
                    name: 'sortOrder',
                    index: 'sortOrder',
                    editable: false,
                    hidden: true
                },
                {
                    name: 'sortType',
                    index: 'sortType',
                    editable: false,
                    hidden: true
                },
                {
                    name: 'usesExpression',
                    index: 'usesExpression',
                    editable: false,
                    hidden: true
                },
                {
                    name: 'expression',
                    index: 'expression',
                    editable: false,
                    hidden: true
                },
                {
                    name: 'visible',
                    index: 'visible',
                    editable: false,
                    hidden: true
                },
                {
                    name: 'width',
                    index: 'width',
                    editable: false,
                    hidden: true
                },
                {
                    name: 'isDefault',
                    index: 'isDefault',
                    editable: false,
                    hidden: true
                },
                {
                    name: 'aggregate',
                    index: 'aggregate',
                    editable: false,
                    hidden: true
                },
                {
                    name: 'includeFilter',
                    index: 'includeFilter',
                    editable: false,
                    hidden: true
                }
            ],
            colNames: ['aggregation', 'align', 'Caption', 'fieldDataType', 'Field', 'fieldId',
                'format', 'formatoption', 'setDynamicFilter', 'sortOrder', 'sortType',
                'usesExpression', 'expression', 'visible', 'width', 'isDefault', 'aggregate', 'includeFilter'],
            test: true
        });

        this.updateColumns();
        this.lookupFieldNamesForDS();
        this.clearSelectedRow();
        this.updateDefaultDataSource();
        this.listenTo(this.model, 'change', this.render);

        if (!util.hasEventListener(eventBus._events, constants.RESIZE_PROPERTIES_STYLE_PANEL)) {
            this.listenTo(eventBus, constants.RESIZE_PROPERTIES_STYLE_PANEL, util.resizeGridWidth);
        }
        
        return this;
    }
      
    updateColumns(){
        let columns = this.model.get('Columns');
        if (!columns) {
            columns = {Column : []};
        } else if ( !(columns.Column instanceof Array) ) {
            columns.Column = [columns.Column]
        }
        let gridData = this.model.get('gridData');
        if(util.isChart( this.model.get('factoryKey'))){
            _.forEach(columns.Column, function(value, key) {
                let col = util._unPrefix(value);
                col.Properties = util._unPrefix(value.Properties);
                columns.Column[key]= col;
                if (gridData[key].usesExpression === 'true'){
                    gridData[key].field = 'Formula';
                    gridData[key].fieldDataType = 'Formula';
                    let expression = value.EXPR.arguments;
                    gridData[key].expression = {};
                    if (expression instanceof Array) {
                        for (let k = 0; k < expression.length; ++k) {
                            expression[k] = util._unPrefix(expression[k]);
                        }
                        if(value.EXPR.id && value.EXPR.type){
                            gridData[key].expression.id = value.EXPR.id;
                            gridData[key].expression.type = value.EXPR.type;
                        }
                        gridData[key].expression.arguments = expression;
                    } else {
                        gridData[key].expression = [ util._unPrefix(expression) ];
                    }
                }
            });
        }else{
            _.forEach(columns.Column, function(value, key) {
                let col = util._unPrefix(value);
                col.Properties = util._unPrefix(value.Properties);
                columns.Column[key]= col;
                if (gridData[key].usesExpression === 'true'){
                    gridData[key].field = 'Formula';
                    gridData[key].fieldDataType = 'Formula';
                    let expression = value.EXPR.EXPR;
                    if (expression instanceof Array) {
                        for (let k = 0; k < expression.length; ++k) {
                            expression[k] = util._unPrefix(expression[k]);
                        }
                        gridData[key].expression = expression;
                    } else {
                        gridData[key].expression = [ util._unPrefix(expression) ];
                    }
                }
            });
        }
        
        this.model.set('Columns', columns);
    }

    updateDefaultDataSource(){
        const currentDataSourceId=this.model.get('dataSourceId');
        if(!currentDataSourceId){
          let firstDataSource=listService.getDataSources().first();
          let cleanDataSourceId= firstDataSource ? listService.cleanId(firstDataSource.id) : undefined;
          // always assign original datasource id to the model
          this.model.set('dataSourceId',listService.getCleanedId(cleanDataSourceId));
          listService.setReportingMetaData(cleanDataSourceId,this.model,true, false, true);
        }
        else{
          listService.setReportingMetaData(currentDataSourceId,this.model,true, true, true);
        }

    }

    saveColumnsMetadata(reordering) {
        let model = this.model;
        const gridData = model.get('gridData');
        _.forEach(gridData, function(value, key) {

            if(reordering){
                if (!util.isTrue(value.usesExpression)){
                    delete model.attributes.Columns.Column[key].EXPR;
                }else if(value.expression){
                    model.attributes.Columns.Column[key].EXPR = {};
                    model.attributes.Columns.Column[key].EXPR.id = value.expression.id;
                    model.attributes.Columns.Column[key].EXPR.arguments = value.expression.arguments;
                    model.attributes.Columns.Column[key].EXPR.type = value.expression.type;
                }
            }

            model.attributes.Columns.Column[key].Properties = Object.assign({}, value);
            model.attributes.Columns.Column[key].Properties.fieldId = listService.getCleanedId(value.fieldId);
        });

        //PF-8736, Remove the metadata and create it again
        listService.deleteReportMetaData(model.get('id'));
        listService.setReportingMetaData(this.model.get('dataSourceId'), this.model, true, true, true);
    }

    itemUp() {  
        let gridData = this.model.get('gridData');
        let rowId = parseInt(this.model.get('rowid'));
        let newRowId = rowId - 1;

        if (rowId > 0) {
            this.saveCurrentScroll();
            gridData[rowId] = gridData.splice((newRowId), 1, gridData[rowId])[0];
            this.model.set('rowid', newRowId);
            this.model.set('gridData', gridData, constants.MODEL_SILENT);
            this.render();
            this.setCurrentScroll();
        }
        this.saveColumnsMetadata(true);
    }

    itemDown() {
        let gridData = this.model.get('gridData');
        let rowId = parseInt(this.model.get('rowid'));
        let newRowId = rowId + 1;

        if (rowId < (gridData.length - 1)) {
            this.saveCurrentScroll();
            gridData[rowId] = gridData.splice(newRowId, 1, gridData[rowId])[0];
            this.model.set('rowid', newRowId);
            this.model.set('gridData', gridData, constants.MODEL_SILENT);
            this.render();
            this.setCurrentScroll();
        }
        this.saveColumnsMetadata(true);
    } 

    itemNew(){
        this.saveCurrentScroll();
        let dataSourceId = this.model.get('dataSourceId');
        if (!dataSourceId || dataSourceId === 'None') {
            return;
        }

        let gridData = this.model.get('gridData');
        let controlWidth = this.model.get('width');
        let newRow = {
            'caption':'Column ' + (gridData.length+1) ,
            'field': 'None',
            'fieldId': '',
            'fieldDataType': '',
            'aggregate': 'Group',
            'width': 150,
            'sortType': 'none',
            'format': 'none',
            'align': 'left',
            'visible': 'true',
            'includeFilter': 'false',
            'isDefault': false,
            'aggregation' : 'group', 
            'setDynamicFilter' : 'false',
            'usesExpression' : 'false', 
            'formatoption' : '',
            'sortOrder' : '0'
        };
        $(this.gridEl).addRowData((gridData.length + 1), newRow);

        this.addReportingMetaDataColumn();
        this.addColumnProperty(newRow);

        gridData.push(newRow);
        // PF-5735 performance improvement (not render)
        this.model.set('gridData', gridData, {silent: true});
        this.model.set(newRow,{silent:true});//setting visible property values to defaults
        this.model.set('width', controlWidth, {silent: true});
        // this.render();
        this.setCurrentScroll();

        // PF-5736
        // Set last row id and then perform method to select it and then render
        this.model.set('rowid',  gridData.length - 1);
        this.activateOnSelectedRow();

    }

    itemRemove() {
        this.saveCurrentScroll();
        let rowid = this.model.get('rowid');
        if(!rowid){return;}
        this.removeColumnProperty(rowid);
        this.removeReportingMetaDataColumn(rowid);
        super.itemRemove();
        this.setCurrentScroll();

    }

    itemSpaceEvenly(){
        var rowid = this.model.get('rowid');
        var gridData = this.model.get('gridData');
        var controlWidth = parseInt(this.model.get('width'), 10);
        var newWidth = Math.trunc( (controlWidth - gridData.length -1) / gridData.length );
        let self = this;
        _.forEach(gridData, function(value, key) {
            gridData[key].columnWidth = newWidth;
            gridData[key].width = newWidth;
            self.updateColumnProperty(key, 'width', newWidth);
        });
        this.model.set('columnWidth', newWidth);
        this.model.set('gridData', gridData, {silent: true});
        this.render();
    }

    clearSelectedRow(){
        this.activateOnSelectedRow();
        this.model.set('columnFieldId', 'none');
        this.model.set('columnSort', 'none');
        this.model.set('columnWidth', '');
        this.model.set('columnAlign', '');
        this.model.set('columnHidden', false);
        this.model.set('columnIncludeFilter', false);
        this.model.set('columnFormat', 'none');
    }

    updateAlignment(ev) {
        ev.preventDefault();
        let rowid = this.model.get('rowid');
        if (rowid) {
            const propName = ev.currentTarget.name;
            const propVal  = ev.currentTarget.title;

            this.setColumnSpecificToGridData( propName, propVal );
            this.updateColumnProperty(rowid, 'align', propVal);
            this.model.set( propName, propVal);
        }
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        let propVal  = ev.currentTarget.value;

        if (this.formatFields.includes(propName)) {
            this.updateFormatAttributes(ev);
            return;
        }

        //PF-2843 Minimum Size that a column should have.
        if(propName === 'columnWidth'){
            propVal = parseInt(propVal) < 20 ? 20: propVal;
        }

        if (ev.currentTarget.className.includes('columnSpecific')){
            this.setColumnSpecificToGridData( propName, propVal )

            var rowid = this.model.get('rowid');
            const map = {
                'columnWidth': 'width'
            };
            const colPropName = map[propName];
            this.updateColumnProperty(rowid, colPropName, propVal);
        }

        if (propName === 'dataSourceId') {
            // remove previous MetaData
            listService.deleteReportMetaData( this.model.get('id'));
            if (propVal !== 'none') {
                // Set new MetaData
                listService.setReportingMetaData(propVal, this.model);
                propVal = listService.getCleanedId(propVal);
            }

            let columns = this.model.get('Columns');
            
            if ( columns ) {
                _.forEach(columns.Column, (row, key) => {
                    super.saveCell(key,'field','None');
                    super.saveCell(key,'fieldId','');
                    super.saveCell(key,'aggregate','Group');
                    super.saveCell(key,'aggregation','group');
                    super.saveCell(key,'sortType','none');
                });                
            }

             let gridFields = this.model.get('gridData');
             if (gridFields) {
                _.forEach(gridFields, field => field.field = "None");                        
                this.render();
             }  
        }

        this.model.set( propName, propVal );
        
        if(propName === 'caption'){
            this.setColumnSpecificToGridData( propName, propVal )
            super.saveCell(this.model.get('rowid'),'caption',propVal);
        }

        if (propName === 'headerHeight'){
            this.model.set('bodyHeight', (160-propVal));
        } 
    }


    saveColumns() {
        let columns = this.model.get('Columns');
            
        if ( columns ) {
            _.forEach(columns.Column, (row, key) => {
                super.saveCell(key,'field','None');
                super.saveCell(key,'fieldId','');
                super.saveCell(key,'aggregate','Group');
                super.saveCell(key,'aggregation','group');
                super.saveCell(key,'sortType','none');
            });                
        }
    }

    updateSelectAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;

        if (ev.currentTarget.className  === 'columnSpecific'){
            this.setColumnSpecificToGridData( propName, propVal )

            let rowid = this.model.get('rowid');
            const map = {
                'columnSort': 'sortType',
                'columnFormat': 'format'
            };
            const colPropName = map[propName];
            this.updateColumnProperty(rowid, colPropName, propVal);
            if (colPropName === 'sortType') {
                this.updateReportingMetaDataColumn(rowid, colPropName, propVal);
            } else if (colPropName === 'format') {
                // put default format values
                this.setDefaultFormatValue(rowid, propVal);
            }
        }
        this.model.set( propName, propVal );
    } 

    updateColumnField(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;
        const dataType = $('#columnFieldId').find(':selected').attr('datatype');

        this.setColumnSpecificToGridData( propName, propVal );
        this.setColumnSpecificToGridData( 'fieldDataType', dataType );
        const fieldName = $("#columnFieldId option:selected").text();

        this.setColumnSpecificToGridData( 'field', fieldName );

        var rowid = this.model.get('rowid');

        this.updateColumnProperty(rowid, 'fieldId', listService.getCleanedId(propVal));
        this.updateColumnProperty(rowid, 'fieldDataType', dataType);
        //this delete all the metadata with its columns  we need to recreat them sending the last value in true in tne next function
        listService.deleteReportMetaData( this.model.get('id'));
        listService.setReportingMetaData(this.model.get('dataSourceId'), this.model, true, undefined, true);
        this.updateReportingMetaDataColumnField(rowid, listService.getCleanedId(propVal), dataType);

        this.model.set( propName, propVal );
    }

    updateCheckAttributes(ev) {
        const propName = ev.currentTarget.name;
        let propVal  = ev.currentTarget.checked;
        var newValue = "";
        if (propVal) {
            newValue = "checked";
        }

        if (this.formatFields.includes(propName)) {
            this.updateFormatAttributes(ev);
            return;
        }

        if ($(ev.currentTarget).hasClass('columnSpecific')) { 
            this.setColumnSpecificToGridData( propName, newValue )

            var rowid = this.model.get('rowid');
            const map = {
                'columnHidden': 'visible',
                'columnIncludeFilter': 'setDynamicFilter'
            };
            const colPropName = map[propName];
            if (colPropName === 'visible') {
                let visible = !propVal;
                this.updateReportingMetaDataColumn(rowid, colPropName, visible.toString());
                this.updateColumnProperty(rowid, colPropName, visible.toString())
            }else{
                this.updateColumnProperty(rowid, colPropName, propVal);
            }

        }
        else {
            if ($(ev.currentTarget).hasClass('pagingControls')) {
                var hideAttribute = propName + 'Hide';
                this.model.set(hideAttribute, newValue ?  '' : 'hidden');
                this.model.set(propName, newValue === 'checked');
            } else if (ev.currentTarget.className === 'timeControls') {
                this.setColumnSpecificToGridData(propName, newValue)
            }

            switch (propName){
                case 'setFilter':
                    this.model.set('setDynamicFilter', propVal, { silent: true });
                    break;
                case 'respectDynamicFilter':
                    this.model.set('respectDynamicFilter', propVal, { silent: true });
                    break;
                case 'showAllValues':
                    this.model.set('ignoreNull', propVal, { silent: true });
                    this.updateReportingMetaData('ignoreNull', propVal);
                    break;
                case 'overridePrevious':
                    this.model.set('additiveDynamicFilter', propVal, { silent: true });
                    break;
            }
        }

        this.model.set( propName, propVal, {silent: true} );
    }
        
    setColumnSpecificToGridData( propName, propVal ){
        var gridData = this.model.get('gridData');
        var rowid = this.model.get('rowid');
        if(!rowid){ rowid = 0; }
        // Adjusting properties name
        let name = propName.replace('column', '').toLowerCase();
        var myRow = gridData[rowid];        
        switch(name){
            case 'includefilter':
                name = 'includeFilter';
                myRow['setDynamicFilter'] = propVal === 'checked';
                break;
            case 'sort':
                name = 'sortType';
                break;
            case 'hidden':
                myRow['visible'] = propVal === 'checked' ? 'false' : 'true';
                break;
            case 'fieldid':
                name = 'fieldId';
                break;
            case 'time24hour':
                name = 'time24Hour';
                break;
            case 'timeshowseconds':
                name = 'timeShowSeconds';
                break;
            case 'fielddatatype':
                name = 'fieldDataType';
                break;
        }

        myRow[name] = propVal;
        gridData[rowid] = myRow;
        this.model.set('gridData', gridData);
        this.saveColumnsMetadata();
    }

    getColumnSpecificFromGridData(rowid){
        var gridData = this.model.get('gridData');
        this.model.set(gridData[rowid]);
    }

    onCellSelect(rowid, iCol, cellcontent,e){
        let self = this;
        this.saveCurrentScroll();
        const rowData = $(this.gridEl).getRowData(rowid);
        if (util.isTrue(rowData['isDefault'])) {
            $(this.gridEl).jqGrid('setColProp', 'caption', {editable: false});
            return;
        }

        const colNames = this.model.get('colNames');
        if (colNames[iCol] === 'Caption' ) {
            this.updateOnRowSelection(rowid, rowData);
            $(this.gridEl).jqGrid('setColProp', 'caption', {editable: true});
        }else if (colNames[iCol] === 'Field' ) {
            this.updateOnRowSelection(rowid, rowData);
        }
    }

    saveCell(rowid, cellname, value){
        var gridData = this.model.get('gridData');            
        gridData[rowid][cellname] = value;
        this.model.set('gridData', gridData, {silent: true});
        this.model.trigger('change');
        this.render();
        this.setCurrentScroll();
    }

    onSelectRow(rowId, status,e){
        this.setCurrentScroll();
    }

    saveCurrentScroll(){
        this.model.set('currentScroll',$('.ui-jqgrid-bdiv.ui-corner-bottom').scrollTop(),{silent:true});
    }

    setCurrentScroll(){
        $('.ui-jqgrid-bdiv.ui-corner-bottom').scrollTop(this.model.get('currentScroll'));
    }

    hideOptions(yes){
        if (yes){
            $('#hideOptions').hide();
            $('#hideDataSource').hide();
            if (this.model.get('factoryKey') === 'control_data_list') {
                $('#hideDataHeader').hide();
            } else {
                $('#hideDataHeader').show();
            }
        } else {
            $('#hideOptions').show();
            $('#hideDataSource').show();
            $('#hideDataHeader').show();
        }
    }

    hideOnShared(yes){
        if (yes) {
            $('#shared-settings-dialog #hideOnShared').hide();
            $('#shared-settings-dialog #hideOnSharedToo').hide();
        } else {
            $('#shared-settings-dialog #hideOnShared').show();
            $('#shared-settings-dialog #hideOnSharedToo').show();
        }
    }

    selectRow(rowId) {
        $(this.gridEl).setSelection(rowId, true);
    }

    activateOnSelectedRow(){
        const rowid = this.model.get('rowid');
        if(rowid) {
            $('#enableOnColumnSelected').find('input, textarea, button, select').removeAttr('disabled')
            $('#enableOnColumnSelected').removeClass(constants.CLASS_HIDDEN);
            this.selectRow(rowid);
        } else {
            $('#enableOnColumnSelected').find('input, textarea, button, select').attr('disabled', 'disabled');
            $('#enableOnColumnSelected').addClass(constants.CLASS_HIDDEN);
        }
    }

    addDefaultEmptyRows(){
        var gridData = this.model.get('gridData');
        let size = gridData.length;
        if (size < this.minRows) {
            var newRow = {
                'caption': '',
                'fieldId': '',
                'field': '',
                'fieldDataType': '',
                'width': 150,
                'align': '',
                'visible': true,
                'setDynamicFilter': false,
                'sortType': 'none',
                'format': 'none',
                'isDefault': true
            };
            for (let i=size; i<this.minRows; ++i) {
                $(this.gridEl).addRowData((gridData.length + 1), newRow);
            }
        }
    }

    updateOnRowSelection(rowId, rowData){
        this.activateOnSelectedRow();
        // show select fields
        this.model.set('columnFieldId', rowData.fieldId, {silent: true});
        $("#columnFieldId option[value='none']").prop('selected', true);  // reset just in case no field is set
        if (rowData.field === 'Formula'){
            $("#columnFieldId option[value='formula']").prop('selected', true);
        }else{
            $("#columnFieldId option[value='" + listService.cleanId(this.model.get('columnFieldId')) + "']").prop('selected', true);
        }
        this.model.set('columnSort', rowData.sortType, {silent: true});
        $("#columnSort option[value='" + this.model.get('columnSort') + "']").prop('selected', true);
        
        //PF-8383 Added column aggregation
        $("#columnAggregate option[value='" + rowData.aggregation + "']").prop('selected', true);

        // show column
        this.model.set('columnWidth', rowData.width, {silent: true});
        $('#columnWidth').val(rowData.width)
        // show the alignment
        this.model.set('columnAlign', rowData.align, {silent: true});
        var alignment = '#align' + rowData.align;
        $('[name="columnAlign"]').css( "background-color", "transparent" );
        $(alignment).css( "background-color", "lightgrey" );
       
        // show checkboxes
        if (!util.isTrue(rowData.visible)){
            this.model.set('columnHidden', 'checked', {silent: true}); 
        } 
        else {
            this.model.set('columnHidden', '', {silent: true}); 
        }

        if (util.isTrue(rowData.setDynamicFilter)) {
            this.model.set('columnIncludeFilter', 'checked', {silent: true}); 
        }
        else {
            this.model.set('columnIncludeFilter', '', {silent: true}); 
        }

        // show column format and sections
        this.model.set('columnFormatOption', rowData.formatoption, {silent: true});
        this.model.set('columnFormat', rowData.format, {silent: true});
        $("#columnFormat option[value='" + this.model.get('columnFormat') + "']").prop('selected', true);
        this.formatView.render();
 
        let gridData = this.model.get('gridData');
        if (gridData && gridData[rowId]) {
            let hiddenValue = !util.isTrue(gridData[rowId].visible) ? 'checked' : '';
            $('#columnHidden').prop('checked', hiddenValue);
    
            let dynamicValue = util.isTrue(gridData[rowId].setDynamicFilter) ? 'checked' : '';
            $('#columnIncludeFilter').prop('checked', dynamicValue); 
        }
    }

    populateDataSources() {
        const elDataSources = $('#dataSource');
        if (elDataSources) {
            const ds = listService.getDataSources();
            ds.map((v, k) => {
                elDataSources[0].options[elDataSources[0].options.length] = new Option(v.name, v.id);
            });
        }
    }

    // Only want to list Fields marked as InUse (Configured in the DataSource)
    loadFieldsFromDatasource( dsId ) {
        const ds = listService.getDataSources(dsId);

        if (ds && ds.Fields && ds.Fields.Field) {
            
            const fieldEl = $('#columnFieldId');
            _.forEach(ds.Fields.Field, (field) => {
                if (util.isTrue(field.inUse)) {
                    let fname = '';

                    switch (field.id) {
                        case 'CreateDate':
                            fname = 'Meta - Last Submission Date';
                            break;
                        case 'E':
                            fname = 'Meta - Instance Number';
                            break;
                        case 'FormInstanceGUID':
                            fname = 'Meta - Instance ID';
                            break;
                        case 'FormInstanceId':
                            fname = 'Meta - Link';
                            break;
                        case 'MajorVersion':
                            fname = 'Meta - Version Major';
                            break;
                        case 'MinorVersion':
                            fname = 'Meta - Version Minor';
                            break;
                        case 'Name':
                            fname = 'Meta - Instance Name';
                            break;
                        case 'ParentGUID':
                            fname = 'Meta - Parent Instance ID';
                            break;
                        case 'StageName':
                            fname = 'Meta - Stage';
                            break;

                        default:
                            fname = field.name.replace('|',' - ');
                            break;
                    }

                    const elOpt = new Option((field.displayName.trim() || fname), listService.cleanId(field.id));
                    fieldEl[0].options[fieldEl[0].options.length] = elOpt;
                    elOpt.setAttribute("dataType", field.dataType);
                }
            })
            const elOpt = new Option('Formula', 'formula');
            fieldEl[0].options[fieldEl[0].options.length] = elOpt;
            elOpt.setAttribute("dataType", 'Formula');
        }
    }

    addReportingMetaDataColumn() {
        const md = listService.getReportingMetaData(this.model.get('id'));
        if (!md.Columns) {
            md.Columns = [];
        }

        const columnSize = md.Columns.length;

        const column = {
            id: columnSize.toString(),
            aggregation: 'group',
            sortType: 'none',
            sortOrder: '0',
            visible: true,
            Expression: {}
        };
        
        column.Expression.id = '';
        column.Expression.type = '';
        column.Expression.Argument = [];
        md.Columns.push(column);

    }

    updateReportingMetaData(propName, propVal){        
        const metaData = listService.getReportingMetaData(this.model.get('id'));
        metaData.set(propName, propVal, {silent: true});
    }

    // Look up Column by ID and set properties
    updateReportingMetaDataColumnField(rowid, dsFieldId, dataType, data ) {
        const md = listService.getReportingMetaData(this.model.get('id'));

        if (md.Columns) {
            _.forEach(md.Columns, (col) => {
               if (col.id.toString() === rowid.toString()) {
                   const aggregate = $('#columnAggregate option:selected').val();
                   const sort = $('#columnSort option:selected').val();

                   col.aggregation = aggregate;
                   col.sortType = sort;
                   if( data && data.arguments && util.isChart(this.model.get('factoryKey')) ){
                        col.Expression.id = data.id;
                        col.Expression.type = data.type;
                        col.Expression.Argument = data.arguments;
                    }else{
                        col.Expression.Argument = {type: 'reporting_datasourceField', value: dsFieldId, dataType: dataType};
                    }
               }
            });
        }
    }

    updateReportingMetaDataColumn(rowid, propName, propVal) {
        const md = listService.getReportingMetaData(this.model.get('id'));

        if (md.Columns) {
            _.forEach(md.Columns, (col) => {
                if (col.id.toString() === rowid.toString()) {
                    col[propName] = propVal;
                }
            });
        }
    }

    removeReportingMetaDataColumn(rowid) {
        const md = listService.getReportingMetaData(this.model.get('id'));

        if (md.Columns) {
            md.Columns.splice(rowid,1);
        }

    }

    lookupFieldNamesForDS() {
        var gridData = this.model.get('gridData');
        const dsId = listService.cleanId(this.model.get('dataSourceId'));

        _.forEach(gridData, function(col) {
            if (!col.field) {
                const fieldId = col.fieldId;
                col.field = listService.getDataSourceFieldName(dsId, fieldId);

            }

        });
    }

    addColumnProperty(row) {
        const columns = this.model.get('Columns');

        const colCount = columns.Column.length;

        columns.Column.push({
            id: colCount,
            Properties: {
                caption: row.caption,
                visible: !row.hidden,
                fieldId: row.fieldId,
                aggregation: row.aggregate,
                align: row.align,
                setDynamicFilter: row.includeFilter,
                sortType: row.sortType,
                format: row.format,
                formatoption: '',
                sortOrder: '0',
                fieldDataType: '',
                width: row.width,
                usesExpression: 'false',
                expression: ''
            }
        });
    }

    removeColumnProperty(rowid) {
        const columns = this.model.get('Columns');
        columns.Column.splice(rowid, 1);
    }

    updateColumnProperty(rowid, propName, propVal) {
        const columns = this.model.get('Columns');
        if (propName === 'expression') {
            if (!columns.Column[rowid].EXPR){
                columns.Column[rowid].EXPR = {};
                columns.Column[rowid].EXPR.id = propVal.id;
                columns.Column[rowid].EXPR.type = propVal.type;
                columns.Column[rowid].EXPR.arguments = propVal.arguments;   
            }else{
                columns.Column[rowid].EXPR.id = propVal.id;
                columns.Column[rowid].EXPR.type = propVal.type;
                columns.Column[rowid].EXPR.arguments = propVal.arguments;
            }
            
        } else {
            columns.Column[rowid].Properties[propName] = propVal;
        }
    }

    showFormulaModal(ev) {
        ev.preventDefault();
        const factoryKey= this.model.get('factoryKey');
        let rowid = this.model.get('rowid');
        let gridData = this.model.get('gridData');

        let expression = null; //this.getParameter(rowid);
        if ( util.isTrue(gridData[rowid].usesExpression)){
            if(util.isChart(factoryKey) && gridData[rowid].expression.arguments){
                expression = {arguments: gridData[rowid].expression.arguments};
            }else{
                expression = {arguments: gridData[rowid].expression};
            }
            
        }
 
        this.model.set('formulaParameter', expression, {silent:true});
        this.model.set('type', 'DataSource', {silent:true});
        this.model.set('title', 'Column Formula', {silent:true});
        var sfModal = new ReportFormulaModal({model: this.model, config: {selected: ''}});
        sfModal.render().then((formulaParameter)=>{
            expression = formulaParameter;
            gridData[rowid].expression = formulaParameter.arguments;
            gridData[rowid].usesExpression = formulaParameter? 'true': false;
            gridData[rowid].fieldDataType = 'Formula';
            gridData[rowid].field = 'Formula';
            gridData[rowid].fieldId = 'Formula';

            this.updateColumnProperty(rowid, 'expression', expression);
            this.saveColumnsMetadata();
            this.updateReportingMetaDataColumnField(rowid, 'Formula', 'NVARCHAR(400)', formulaParameter); 
            let model = this.model;
            _.forEach(gridData, function(value, key) {
                model.attributes.Columns.Column[key].Properties = Object.assign({}, value);
                model.attributes.Columns.Column[key].Properties.fieldId = listService.getCleanedId(value.fieldId);
            });
            this.model.trigger('change');
            //this.recalculateWidgetText();
        }).catch(err => {
            console.log(err)
        });
    }

    setDefaultFormatValue(rowid, propVal) {
        let columns = this.model.get('Columns');
        let formatOption ='';
        switch(propVal){
            case 'date':
                formatOption = 'MM/DD/YYYY';
                break;
            case 'number':
                formatOption = '2|,| |';
                break;
            case 'boolean':
                formatOption = '|';
                break;
            case 'time':
                formatOption = 'true|false';
                break;
            case 'percentage':
                formatOption = '2';
                break;
            case 'none':
                formatOption = '';
                break;
        }
        columns.Column[rowid].Properties['formatoption'] = formatOption;
        this.model.set('Columns', columns, {silent: true});
        this.model.set('columnFormatOption', formatOption, {silent: true});

        let gridData = this.model.get('gridData');
        gridData[rowid].formatoption = formatOption;
        this.model.set('gridData', gridData);

        let selectedRowData = $(this.gridEl).getRowData(rowid);
        selectedRowData.formatoption = formatOption;
        $(this.gridEl).setRowData(rowid, selectedRowData);
    }


    updateFormatAttributes(ev){
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        let propVal  = ev.currentTarget.value;
        let rowid = this.model.get('rowid');
        let columns = this.model.get('Columns');
        let formatOption = columns.Column[rowid].Properties['formatoption'];
        let options = formatOption? formatOption.split('|') : null;
        switch (propName) {
            case 'numberDecimals':
                if (!options) {
                    options= '2|,| |'.split('|');
                }
                options[0] = propVal;
                break;
            case 'numberDecimalSeparator':
                if (!options) {
                    options= '2|,| |'.split('|');
                }
                options[1] = textUtil.convertTextToSymbol(propVal);
                break;
            case 'numberThousandSeparator':
                if (!options) {
                    options= '2|,| |'.split('|');
                }
                options[2] = textUtil.convertTextToSymbol(propVal);
                break;
            case 'numberSymbol':
                if (!options) {
                    options= '2|,| |'.split('|');
                }
                options[3] = propVal;
                break;
            case 'dateFormat':
                if (!options) {
                    options= 'MM/DD/YYYY'.split('|');
                }
                options[0] = propVal;
                break;
            case 'time24Hour':
                propVal = ev.currentTarget.checked;
                if (!options) {
                    options= '|'.split('|');
                }
                options[0] = propVal? 'true' : 'false';
                break;
            case 'timeShowSeconds':
                propVal = ev.currentTarget.checked;
                if (!options) {
                    options= '|'.split('|');
                }
                options[1] = propVal? 'true' : 'false';
                break;
            case 'booleanYes':
                if (!options) {
                    options= '|'.split('|');
                }
                options[0] = propVal;
                break;
            case 'booleanNo':
                if (!options) {
                    options= '|'.split('|');
                }
                options[1] = propVal;
                break;
            case 'percentageDecimals':
                if (!options) {
                    options= ''.split('|');
                }
                options[0] = propVal;
                break;
        }

        formatOption ='';
        for (let o in options) {
            formatOption += options[o] + '|'
        }
        formatOption = formatOption.slice(0, -1);

        columns.Column[rowid].Properties['formatoption'] = formatOption;
        this.model.set('Columns', columns, {silent: true});
        this.model.set('columnFormatOption', formatOption, {silent: true});

        let gridData = this.model.get('gridData');
        gridData[rowid].formatoption = formatOption;
        this.model.set('gridData', gridData);

        let selectedRowData = $(this.gridEl).getRowData(rowid);
        selectedRowData.formatoption = formatOption;
        $(this.gridEl).setRowData(rowid, selectedRowData);
    }

    afterRender(){
        this.addDefaultEmptyRows();
        var gridData = this.model.get('gridData');

        this.formatView = new FormatView({
            model: this.model,
            el: this.$el.find('#formatTarget')
        }).render();

        var alignment = '#align' + this.model.get('columnAlign')
        $(alignment).css( "background-color", "lightgrey" );

        if (this.model.get('hasAggregate')){
            this.mainDataAggregateView = new MainDataAggregateView({
                model: this.model,
                el: this.$el.find('#aggregateTarget')
            }).render();
        }

        $("#columnSort option[value='" + this.model.get('columnSort') + "']").prop('selected', true);
        $("#columnFormat option[value='" + this.model.get('columnFormat') + "']").prop('selected', true);

        let showNavButtons = util.isTrue(this.model.get('showNavButtons'));
        $(`input[name='showNavButtons']`).prop('checked', showNavButtons );

        let showDsInfo = util.isTrue(this.model.get('showDsInfo'));
        $(`input[name='showDsInfo']`).prop('checked', showDsInfo );

        let allowExport = util.isTrue(this.model.get('allowExport'));
        $(`input[name='allowExport']`).prop('checked', allowExport );

        let variableRowHeight = util.isTrue(this.model.get('variableRowHeight'));
        $(`input[name='variableRowHeight']`).prop('checked', variableRowHeight );

        let shared = false;
        if ($('#shared-settings-dialog').length > 0) {
            shared = true;
        }
        if (formModel.attributes.currentDevice!== 'deviceDesktop' && !shared) {
            this.hideOptions(true);
        } else if (shared) {
            this.hideOnShared(true)
        } else {
            this.hideOptions(false);
            this.hideOnShared(false)
        }

        this.activateOnSelectedRow();
        this.populateDataSources();

        const currentDataSourceId=this.model.get('dataSourceId');

        if (currentDataSourceId && currentDataSourceId !== 'none') {
            $('#dataSource').find('option[value=' + listService.cleanId(this.model.get('dataSourceId')) + ']').attr('selected', true);
            this.loadFieldsFromDatasource(listService.cleanId(this.model.get('dataSourceId')));
         }else{
            $('#dataSource').find('option[value=' + currentDataSourceId + ']').attr('selected', true);
        }
        $("#columnFieldId option[value='" + this.model.get('columnFieldId') + "']").prop('selected', true);


        const selectedRowId= this.model.get('rowid');
        if(selectedRowId) {
            const selectedRowData = $(this.gridEl).getRowData(selectedRowId);
            this.updateOnRowSelection(selectedRowId,selectedRowData);
        }
    }
}

export default MainDataView;
